import {
  TOGGLE_SHOW_EDIT_SELECTION,
  TOGGLE_SHOW_JUMP_TO_PICK_NR,
  TOGGLE_SHOW_EDIT_DRIVES,
  TOGGLE_SHOW_EDIT_PICKS,
  TOGGLE_SHOW_INFO,
  TOGGLE_VISIBILITY_EDIT_SELECTION,
  TOGGLE_VISIBILITY_JUMP_TO_PICK_NR,
  TOGGLE_VISIBILITY_EDIT_DRIVES,
  TOGGLE_VISIBILITY_EDIT_PICKS,
  TOGGLE_VISIBILITY_INFO
} from "./constants";

const regex = /^(showComponents\/)/;

const _TOGGLE_SHOW_EDIT_SELECTION = TOGGLE_SHOW_EDIT_SELECTION.replace(
  regex,
  ""
);
const _TOGGLE_SHOW_JUMP_TO_PICK_NR = TOGGLE_SHOW_JUMP_TO_PICK_NR.replace(
  regex,
  ""
);
const _TOGGLE_SHOW_EDIT_DRIVES = TOGGLE_SHOW_EDIT_DRIVES.replace(regex, "");
const _TOGGLE_SHOW_EDIT_PICKS = TOGGLE_SHOW_EDIT_PICKS.replace(regex, "");
const _TOGGLE_SHOW_INFO = TOGGLE_SHOW_INFO.replace(regex, "");

export default {
  [_TOGGLE_SHOW_EDIT_SELECTION]({ commit }) {
    commit(TOGGLE_VISIBILITY_EDIT_SELECTION);
  },
  [_TOGGLE_SHOW_JUMP_TO_PICK_NR]({ commit }) {
    commit(TOGGLE_VISIBILITY_JUMP_TO_PICK_NR);
  },
  [_TOGGLE_SHOW_EDIT_DRIVES]({ commit }) {
    commit(TOGGLE_VISIBILITY_EDIT_DRIVES);
  },
  [_TOGGLE_SHOW_EDIT_PICKS]({ commit }) {
    commit(TOGGLE_VISIBILITY_EDIT_PICKS);
  },
  [_TOGGLE_SHOW_INFO]({ commit }) {
    commit(TOGGLE_VISIBILITY_INFO);
  }
};
